import { render, staticRenderFns } from "./ChipsSelection.vue?vue&type=template&id=b4e917d2&scoped=true"
import script from "./ChipsSelection.vue?vue&type=script&lang=js"
export * from "./ChipsSelection.vue?vue&type=script&lang=js"
import style0 from "./ChipsSelection.vue?vue&type=style&index=0&id=b4e917d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e917d2",
  null
  
)

export default component.exports